var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.663 11.193c0-5.888-4.773-10.662-10.663-10.662s-10.662 4.774-10.662 10.662c0 3.468 1.661 6.542 4.225 8.487l-0.005 0.003c0.049 0.033 0.099 0.071 0.152 0.112 0.005 0.004 0.010 0.008 0.015 0.011 0.825 0.651 2.011 2.173 2.011 4.181v7.482h8.53v-7.482c0-2.133 1.232-3.663 2.133-4.271l-0.003-0.003c2.589-1.944 4.268-5.033 4.268-8.52zM12.801 30.403v-3.217h6.398v3.217h-6.398zM16 12.259c-0.588 0-1.066-0.478-1.066-1.066s0.479-1.067 1.066-1.067 1.066 0.479 1.066 1.067c0 0.588-0.479 1.066-1.066 1.066zM21.755 18.861c-0.014 0.011-0.028 0.022-0.042 0.033-1.18 0.839-2.514 2.646-2.514 5.093v2.133h-2.666v-12.87c0.918-0.238 1.599-1.065 1.599-2.056 0-1.178-0.955-2.133-2.133-2.133s-2.133 0.955-2.133 2.133c0 0.992 0.681 1.819 1.599 2.056v12.87h-2.666v-2.133c0-2.296-1.302-4.138-2.407-5.010-0.008-0.007-0.019-0.015-0.029-0.023-0.035-0.027-0.069-0.053-0.102-0.078-0.018-0.016-0.036-0.031-0.056-0.045-2.417-1.834-3.804-4.618-3.804-7.638 0-5.291 4.305-9.596 9.596-9.596s9.596 4.305 9.596 9.596c-0 3.040-1.4 5.834-3.842 7.667z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSvgrepoCom);
export default __webpack_public_path__ + "static/media/light-svgrepo-com.ef92d05a6a0acabf5f422710014cf89d.svg";
export { ForwardRef as ReactComponent };